/**
 * @Author: 派同学
 * @Description: How
 */
export const Loading = {
  tag: 'loading',
  newcover: 'https://luckycola.com.cn/public/imgs/luckycola_Imghub_forever_z4rzBI9s17094596565991217.jpeg',
  basicInfo: {
    cover: 'https://luckycola.com.cn/public/imgs/luckycola_Imghub_forever_z4rzBI9s17094596565991217.jpeg',
    tag: 'loading'
  }
}
